import { Component, Inject, forwardRef } from '@angular/core';
import { smoothlyMenu } from '../../app.helpers';
import { AppComponent } from 'app/app.component';
import { AuthService } from 'app/core/core.module';
import { Router } from '@angular/router';
declare var jQuery: any;

@Component({
    standalone: false,
    selector: 'topnavbar',
    templateUrl: 'topnavbar.template.html',
})
export class TopNavbarComponent {
        constructor(@Inject(forwardRef(() => AppComponent)) public app: AppComponent, public auth: AuthService, private router: Router) {}

    toggleNavigation(): void {
        if (this.auth.currentUser.userName === 'timeCard' || this.auth.currentUser.userName === 'feedmill' || this.auth.currentUser.userName === 'remote') return;
        jQuery('body').toggleClass('mini-navbar');
        smoothlyMenu();
        console.log('', this.router);
    }
}
